import React from 'react';
import PropTypes from 'prop-types';
import colors from 'theme/_colors.scss';

const IconPrediction = ({ width = 16, height = 16, color = colors.doveGray }) =>
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 16 16' fill='none'>
        <path d='M15 14V15H1V14H15ZM15 2V7H13.66V4.34L9 9L7 7L1 13V11L7 5L9 7L12.63 3.37H10V2H15Z' fill={color} />
    </svg>
    ;

IconPrediction.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    color: PropTypes.string
};
export default IconPrediction;
